module.exports = __webpack_public_path__ + "img/public/AdminIcons/documentVerification.svg?f93dbb41";